import { ISettingsState } from "@domain/model/SettingsState";
import { ISettingsService } from "@domain/services/ISettingsService";
import { create } from "@movicoders/store";

export const useSettingsService = create<ISettingsService>((set, get) => ({
  saveSettigsState: (newState: ISettingsState) => set({ persistedState: newState }),
  clearSettingsState: () => set({ persistedState: undefined })
})).build();
